(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["earths-water-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function initComparison(root) {
    if (!root) return;
    if (root.dataset.ewcReady === 'true') return;
    root.dataset.ewcReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));

    function activateTab(tab, moveFocus) {
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.setAttribute('tabindex', selected ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });

      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var targetIndex = index;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;
        if (targetIndex !== index) {
          event.preventDefault();
          activateTab(tabs[targetIndex], true);
        }
      });
    });
  }

  function initComparisons(container) {
    if (container.matches && container.matches('[data-earths-water-comparison]')) {
      initComparison(container);
    }
    container.querySelectorAll('[data-earths-water-comparison]').forEach(initComparison);
  }

  initComparisons(document);
  document.addEventListener('shopify:section:load', function (event) {
    initComparisons(event.target);
  });
  })();

  } catch(e) { console.error(e); }
})();
})();
